import React from "react";
import { Link } from "react-router-dom";
import {
  Logo,
  IconLink,
  Widget,
  AboutWidget,
  CategoryWidget,
  FormTwo,
  TableOne,
} from "../../components";

// Widget Datas
import widgetsdata from "../../data/widgets.json";

const { pageList, exploreLinks } = widgetsdata;

const FooterTwo = () => (
  <footer
    className="footer-wrapper footer-layout2 background-image"
    style={{ backgroundImage: "url(images//bg/footer-bg-2-1.jpg)" }}
  >
    <div className="footer-top">
      <div className="container">
        <div className="row align-items-center justify-content-between gy-30">
          <div className="col-sm-auto">
            <Logo image="/images/logo-white.png" />
          </div>
          <div className="col-sm-auto">
            <IconLink className="footer-social" title="Follow Us On:">
              {/* <IconLink.Item icon="fab fa-facebook-f" path="/" />
              <IconLink.Item icon="fab fa-twitter" path="/" />
              <IconLink.Item icon="fab fa-behance" path="/" />
              <IconLink.Item icon="fab fa-youtube" path="/" />
              <IconLink.Item icon="fab fa-instagram" path="/" /> */}
              <IconLink.Item icon="fab fa-linkedin" path="https://www.linkedin.com/company/tech-ayukta/posts/?feedView=all" target="_blank" />
            </IconLink>
          </div>
        </div>
      </div>
    </div>
    <div className="widget-area">
      <div className="container">
        <div className="row justify-content-between gx-80">
          <div className="col-md-6 col-lg-4 col-xl-auto col-xxl order-2 order-lg-1">
            <Widget
              widgetTitle="Quick Links"
              className="footer-widget widget_nav_menu"
            >
              <CategoryWidget className="footer-links">
                {pageList.map((cat) => (
                  <CategoryWidget.Item key={cat.name} path={cat.path}>
                    {cat.name}
                  </CategoryWidget.Item>
                ))}
                {exploreLinks.map((cat) => (
                  <CategoryWidget.Item key={cat.name} path={cat.path}>
                    {cat.name}
                  </CategoryWidget.Item>
                ))}
              </CategoryWidget>
            </Widget>
          </div>
          <div className="col-lg-4 col-xl-auto order-1 order-lg-2">
            <Widget widgetTitle="About Company" className="footer-widget">
              <AboutWidget>
                <AboutWidget.Text>
                  At Tech Ayukta, we empower businesses with innovative,
                  scalable, and reliable technology solutions. From web and
                  mobile development to ERP, SAP, and managed IT services, we
                  design and deliver solutions that help organizations stay
                  competitive in the digital age.
                </AboutWidget.Text>
                <AboutWidget.Text>
                  Our mission is to blend innovation with trust, delivering solutions that meet industry standards while creating real business value. Through collaboration, transparency, and lasting partnerships, we aim to be your trusted technology partner in driving growth and digital transformation.
                </AboutWidget.Text>

                {/* <FormTwo /> */}
              </AboutWidget>
            </Widget>
          </div>
          <div className="col-md-6 col-lg-4 col-xl-auto order-3">
            <Widget
              widgetTitle="Need Help? Contact Us"
              className="footer-widget"
            >
              <div
                className="footer-number"
                style={{
                  "border-top": "none",
                  padding: "0 0 0 0",
                  margin: "0 0 23px 0",
                }}
              >
                <h4 className="title h6">Contact Us</h4>
                <a href="tel:+919167195907" className="info">
                  (+91) 9167195907
                </a>
              </div>
              <div className="footer-email" style={{ margin: "0 0 23px 0" }}>
                <h4 className="title h6">Email Support</h4>
                <a href="mailto:techsupport@techayukta.com" className="info">
                  techsupport@techayukta.com
                </a>
              </div>
              <div className="footer-address">
                <h4 className="title h6">Office Address</h4>
                <p className="info">
                  Accord Commercial Complex,
                  <br />
                  Near BEST Bus Depot,
                  <br />
                  Goregaon East, Mumbai 400063
                </p>
              </div>
            </Widget>
          </div>
        </div>
      </div>
    </div>
    <div className="copyright-wrap">
      <div className="container">
        <p className="copyright-text">
          Copyright <i className="fal fa-copyright" /> 2025{" "}
          <Link className="text-white" to="/">
            Tech Ayukta
          </Link>
          . All rights reserved by{" "}
          <a className="text-white" href="https://techayukta.com">
            Tech-Ayukta
          </a>
          .
        </p>
      </div>
    </div>
  </footer>
);

export default FooterTwo;
